module.exports = __webpack_public_path__ + "static/media/delete-white.6c5c22ed.svg";